import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { TournamentInfoModalCountdown } from './tournament-info-modal-countdown';
import { T, TournamentDurationTypeNames } from '../../../../constants';
import { TournamentModalImages } from './tournament-modal-images';
import { useStore, useTranslation } from '../../../../hooks';
import { TournamentEntryType } from '../../../../enums';
import { TournamentInfo } from '../../../../models';

import PascalLogo from '../../../../assets/media/tournament/pascal-logo.svg';
import CloseImage from '../../../../assets/media/tournament/close.svg';

interface TournamentInfoModalProps {
  data: TournamentInfo;
}

export const TournamentInfoModal: React.FC<TournamentInfoModalProps> = observer(({ data }) => {

  const { gameStore, tournamentStore } = useStore();
  const { currencySymbol } = gameStore;

  const {
    id,
    canJoin,
    endDate,
    isJoined,
    startDate,
    entryType,
    durationType,
    prizePoolAmount
  } = data;

  const t = useTranslation();

  const isFreeRoll = entryType === TournamentEntryType.FreeRoll

  const joinButtonKey = useMemo(() => {
    if (canJoin && !isFreeRoll) {
      if (isJoined) {
        return T.REBUY;
      }
      return T.JOIN
    }
    return T.SEE_DETAILS;

  }, [canJoin, isFreeRoll, isJoined]);

  const onClose = useCallback(() => {
    tournamentStore.setTournamentInfoModalOpen(false);
  }, []);

  const onJoinButtonClick = useCallback(() => {
    onClose();
    tournamentStore.openTournamentFrame(id);
  }, [onClose, id]);

  return (
    <div className="tournament-popup-layer">
      <div className="tournament-popup-wrapper">
        <div
          role="button"
          onClick={onClose}
          className="tournament-game-wrapper-closer"
        >
          <img className="close-img" src={CloseImage} alt="Close" />
        </div>
        <div className="tournament-popup-top-img"></div>
        <div className="tournament-popup-game-wrapper">
          {
            TournamentDurationTypeNames[durationType] ? (
              <div className="popup-type">
                <span className="popup-type-txt" id="tournamentDurationType">
                  {t(TournamentDurationTypeNames[durationType])}
                </span>
              </div>
            ) : null
          }
          <h2 className="tournament-popup-title">
            {t(T.THIS_GAME_NOW_IS_ON_TOURNAMENT)}
          </h2>
          <div className={`tournament-game-type-wr ${isFreeRoll ? '' : 'emtpy'}`}>
            {
              isFreeRoll && (
                <div className="tournament-game-type">
                  <span className="tournament-game-type-txt">
                    {t(T.FREE_ROLL)}
                  </span>
                </div>
              )
            }
          </div>
          <div className={`tournament-game-many ${isFreeRoll ? 'purple-bg' : 'pink-bg'}`}>
            <div className="tournament-game-many-title">
              <img src={PascalLogo} alt="Logo" />
            </div>
            <div className="tournament-game-many-number">
              <div className="tournament-game-many-number-inner">
                <span className="tournament-game-many-number-txt">{prizePoolAmount}</span>
              </div>
              <div className="tournament-game-many-unit-block">
                <div className="tournament-game-many-unit-block-inner">
                  <span className="tournament-game-many-unit-block-txt">{currencySymbol}</span>
                </div>
              </div>
            </div>
          </div>

          <TournamentInfoModalCountdown
            startDate={startDate}
            endDate={endDate}
            onFinish={onClose}
          />

          <label className="dont-show-again-label">
            <input
              name="check"
              type="checkbox"
              id="dontShowAgainCheckbox"
            />
            <span className="checkmark"></span>
            {t(T.DONT_SHOW_THIS_AGAIN)}
          </label>
          <div className="tournament-game-btn-wrapper">
            <button className="tournament-game-btn" onClick={onJoinButtonClick}>
              {t(joinButtonKey)}
            </button>
          </div>
        </div>
        <TournamentModalImages />
      </div>
    </div >
  );
});
